import type { ColorType } from './types'

export const getTitleColor = (color?: ColorType, underlinedTitle?: boolean) => {
  if (color) {
    return color
  }
  if (underlinedTitle) {
    return 'brandDark'
  }
  return 'uiDark'
}
